import * as yup from 'yup';

export const validation = yup.object().shape({
  clientName: yup
    .string()
    .nullable()
    .required('Name is required'),

  clientEmail: yup
    .string()
    .email('Email must be valid')
    .nullable()
    .required('Email is required'),
});

export enum InviteType {
  Share = 'share',
  Compare = 'compare',
}
